import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <footer className="app-footer">
      <span className="app-footer__text">
        Topcon video translation and synchronization Platform &nbsp;–&nbsp; Internal Use Only
      </span>
    </footer>
  );
}

export default Footer;
